import type { Motor_Lead_Extensions } from "gql/api";

export function computeMleLabel(
  mle?: Partial<Motor_Lead_Extensions> | null
): string {
  if (!mle) return "";

  const label = `${mle.manufacturer} / ${mle.gauge} gauge / ${mle.part_number}`;

  return label;
}
